import {
  BrickInfo,
  defaultBrick,
  brick1x1,
  brick1x2,
  brick1x4,
  brick2x2,
  brick2x4,
  plate1x1,
  plate1x2,
  plate1x4,
  plate2x2,
  plate2x4,
  minifig_megaphone,
  minifig_binoculars,
  minifig_jackhammer,
  minifig_moviecamera,
  minifig_metaldetector,
  minifig_chisel,
  minifig_suitcase,
  minifig_space_binoculars,
  minifig_walkietalkie,
  minifig_miniaxe,
  bionicle_sphere_holder,
  bionicle_krana_holder,
  bionicle_head,
  bionicle_toa_metru_foot,
  bionicle_bohrok_windscreen,
  bionicle_toa_nuva_chest_armor,
  bionicle_claw,
  bionicle_ball_joint,
  bionicle_axle_tooth,
  bionicle_tooth,
  minifig_katana,
  minifig_shortsword,
  minifig_telescope,
  minifig_oil_can,
  minifig_drill,
  minifig_wand,
  minifig_pulley_wand,
  minifig_circular_saw,
  minifig_saber_hilt,
  minifig_space_scanner,
  animal_horse,
  animal_octopus,
  animal_dog,
  animal_dinosaur_baby,
  animal_bat,
  animal_snake,
  animal_owl,
  animal_butterfly,
  animal_crab,
  animal_spider,
  bionicle_ruru_mask,
  bionicle_rau_mask,
  bionicle_matatu_mask,
  bionicle_mahiki_mask,
  bionicle_pakari_mask,
  bionicle_miru_mask,
  bionicle_kau_kau_mask,
  bionicle_kakama_mask,
  bionicle_hau_mask,
  bionicle_huna_mask,
  slope1x1,
  slope2x1,
  slope3x1,
  slope4x1,
  slope2x2,
  slope4x2,
  inverted_slope2x2,
  inverted_slope3x2,
  inverted_slope4x2_doublepins,
  curved_slope2x1,
  dish_2x2_radar,
  wheel_11mm,
  dish_4x4_radar,
  dish_10x10_radar,
  barrel_2x2x2_radar,
  barrel_4x4x35_radar,
  brick_round_4x4,
  cylinder_4x4,
  cylinder_3x6,
  dish_6x6_webbed,
  minifig_hair_male_smooth,
  minifig_hair_female_ponytail,
  minfig_hair_angular_swept,
  minfig_hair_angular_sideways,
  minifig_short_wavy,
  minifig_pointed_hair,
  minifig_hair_pulled_back,
  minfig_hair_tousled,
  minfig_long_hair_and_beard,
  minifig_shaggy_hair_with_beard,
  technic_bush,
  technic_axle_1l_with_pin,
  technic_axle_3l_with_stop,
  technic_brick_1x1_with_axle_hole,
  technic_brick_1x4_with_hole,
  technic_axle_connecter,
  technic_axle_pin_connector,
  technic_gear_24_tooth,
  technic_steering_pulley,
  technic_throwbot_arm,
  minfig_chef_hat,
  minfig_underwater_helmet,
  minfig_rebel_pilot_helmet,
  minfig_witch_hat,
  minfig_scout_trooper_helmet,
  minfig_pirate_hat,
  minfig_police_hat,
  minfig_mining_helmet,
  minfig_wide_brim_hat,
  minfig_hood,
} from "./BrickInfo";

// -----
// *** These values should never be changed by player ***
// -----
export const BrickInfoTotal: Map<string, BrickInfo> = new Map([
  [defaultBrick.id, defaultBrick],
  //
  // Bricks
  //
  [brick1x1.id, brick1x1],
  [brick1x2.id, brick1x2],
  [brick1x4.id, brick1x4],
  [brick1x4.id, brick1x4],
  [brick2x2.id, brick2x2],
  [brick2x4.id, brick2x4],
  //
  // Plates
  //
  [plate1x1.id, plate1x1],
  [plate1x2.id, plate1x2],
  [plate1x4.id, plate1x4],
  [plate2x2.id, plate2x2],
  [plate2x4.id, plate2x4],
  //
  // Sloped Bricks #1
  //
  [slope1x1.id, slope1x1],
  [slope2x1.id, slope2x1],
  [slope3x1.id, slope3x1],
  [slope4x1.id, slope4x1],
  [slope2x2.id, slope2x2],
  [slope4x2.id, slope4x2],
  [inverted_slope2x2.id, inverted_slope2x2],
  [inverted_slope3x2.id, inverted_slope3x2],
  [inverted_slope4x2_doublepins.id, inverted_slope4x2_doublepins],
  [curved_slope2x1.id, curved_slope2x1],
  //
  // Minifig Utensils #1
  //
  [minifig_megaphone.id, minifig_megaphone],
  [minifig_binoculars.id, minifig_binoculars],
  [minifig_jackhammer.id, minifig_jackhammer],
  [minifig_chisel.id, minifig_chisel],
  [minifig_moviecamera.id, minifig_moviecamera],
  [minifig_metaldetector.id, minifig_metaldetector],
  [minifig_suitcase.id, minifig_suitcase],
  [minifig_space_binoculars.id, minifig_space_binoculars],
  [minifig_walkietalkie.id, minifig_walkietalkie],
  [minifig_miniaxe.id, minifig_miniaxe],
  //
  // Bionicle Pieces #1
  //
  [bionicle_tooth.id, bionicle_tooth],
  [bionicle_axle_tooth.id, bionicle_axle_tooth],
  [bionicle_head.id, bionicle_head],
  [bionicle_ball_joint.id, bionicle_ball_joint],
  [bionicle_claw.id, bionicle_claw],
  [bionicle_krana_holder.id, bionicle_krana_holder],
  [bionicle_toa_nuva_chest_armor.id, bionicle_toa_nuva_chest_armor],
  [bionicle_bohrok_windscreen.id, bionicle_bohrok_windscreen],
  [bionicle_sphere_holder.id, bionicle_sphere_holder],
  [bionicle_toa_metru_foot.id, bionicle_toa_metru_foot],
  //
  // Animals #1
  //
  [animal_horse.id, animal_horse],
  [animal_octopus.id, animal_octopus],
  [animal_dog.id, animal_dog],
  [animal_dinosaur_baby.id, animal_dinosaur_baby],
  [animal_bat.id, animal_bat],
  [animal_snake.id, animal_snake],
  [animal_owl.id, animal_owl],
  [animal_butterfly.id, animal_butterfly],
  [animal_crab.id, animal_crab],
  [animal_spider.id, animal_spider],
  //
  // Minifig Utensils #2
  //
  [minifig_space_scanner.id, minifig_space_scanner],
  [minifig_katana.id, minifig_katana],
  [minifig_shortsword.id, minifig_shortsword],
  [minifig_telescope.id, minifig_telescope],
  [minifig_oil_can.id, minifig_oil_can],
  [minifig_drill.id, minifig_drill],
  [minifig_wand.id, minifig_wand],
  [minifig_pulley_wand.id, minifig_pulley_wand],
  [minifig_circular_saw.id, minifig_circular_saw],
  [minifig_saber_hilt.id, minifig_saber_hilt],
  //
  // Bionicle Pieces #2
  //
  [bionicle_ruru_mask.id, bionicle_ruru_mask],
  [bionicle_rau_mask.id, bionicle_rau_mask],
  [bionicle_matatu_mask.id, bionicle_matatu_mask],
  [bionicle_mahiki_mask.id, bionicle_mahiki_mask],
  [bionicle_pakari_mask.id, bionicle_pakari_mask],
  [bionicle_miru_mask.id, bionicle_miru_mask],
  [bionicle_kau_kau_mask.id, bionicle_kau_kau_mask],
  [bionicle_kakama_mask.id, bionicle_kakama_mask],
  [bionicle_hau_mask.id, bionicle_hau_mask],
  [bionicle_huna_mask.id, bionicle_huna_mask],
  //
  // Circular Bricks
  //
  [dish_2x2_radar.id, dish_2x2_radar],
  [wheel_11mm.id, wheel_11mm],
  [dish_4x4_radar.id, dish_4x4_radar],
  [dish_10x10_radar.id, dish_10x10_radar],
  [barrel_2x2x2_radar.id, barrel_2x2x2_radar],
  [barrel_4x4x35_radar.id, barrel_4x4x35_radar],
  [brick_round_4x4.id, brick_round_4x4],
  [cylinder_4x4.id, cylinder_4x4],
  [cylinder_3x6.id, cylinder_3x6],
  [dish_6x6_webbed.id, dish_6x6_webbed],
  //
  // Minifig Hair
  //
  [minifig_hair_male_smooth.id, minifig_hair_male_smooth],
  [minifig_hair_female_ponytail.id, minifig_hair_female_ponytail],
  [minfig_hair_angular_swept.id, minfig_hair_angular_swept],
  [minfig_hair_angular_sideways.id, minfig_hair_angular_sideways],
  [minifig_short_wavy.id, minifig_short_wavy],
  [minifig_pointed_hair.id, minifig_pointed_hair],
  [minifig_hair_pulled_back.id, minifig_hair_pulled_back],
  [minfig_hair_tousled.id, minfig_hair_tousled],
  [minfig_long_hair_and_beard.id, minfig_long_hair_and_beard],
  [minifig_shaggy_hair_with_beard.id, minifig_shaggy_hair_with_beard],
  //
  // Technic
  //
  [technic_bush.id, technic_bush],
  [technic_axle_1l_with_pin.id, technic_axle_1l_with_pin],
  [technic_axle_3l_with_stop.id, technic_axle_3l_with_stop],
  [technic_brick_1x1_with_axle_hole.id, technic_brick_1x1_with_axle_hole],
  [technic_brick_1x4_with_hole.id, technic_brick_1x4_with_hole],
  [technic_axle_connecter.id, technic_axle_connecter],
  [technic_axle_pin_connector.id, technic_axle_pin_connector],
  [technic_gear_24_tooth.id, technic_gear_24_tooth],
  [technic_steering_pulley.id, technic_steering_pulley],
  [technic_throwbot_arm.id, technic_throwbot_arm],
  //
  // Minifig Headgear
  //
  [minfig_chef_hat.id, minfig_chef_hat],
  [minfig_underwater_helmet.id, minfig_underwater_helmet],
  [minfig_rebel_pilot_helmet.id, minfig_rebel_pilot_helmet],
  [minfig_witch_hat.id, minfig_witch_hat],
  [minfig_scout_trooper_helmet.id, minfig_scout_trooper_helmet],
  [minfig_pirate_hat.id, minfig_pirate_hat],
  [minfig_police_hat.id, minfig_police_hat],
  [minfig_mining_helmet.id, minfig_mining_helmet],
  [minfig_wide_brim_hat.id, minfig_wide_brim_hat],
  [minfig_hood.id, minfig_hood],
]);
